/**
 * Publik portal marshrutlari. Eski `#anchor` havolalari (CMS menyusi, zaxira
 * ro'yxat) shu jadval orqali marshrutga o'giriladi.
 *
 * Faqat ikkita band bosh sahifa ichida: «Bosh sahifa» (yuqori qism) va
 * «Yangiliklar» (bosh sahifadagi yangiliklar bloki). Qolgan modullar o'z
 * sahifasida ochiladi.
 */
export const SECTION_PATHS: Record<string, string> = {
  about: "/haqida",
  news: "/yangiliklar",
  subsystems: "/tizimlar",
  services: "/xizmatlar",
  appeal: "/murojaat",
  tracking: "/kuzatish",
  map: "/xarita",
  guides: "/yoriqnomalar",
  media: "/media",
  "mobile-app": "/ilova",
  faq: "/savol-javob",
  contact: "/aloqa",
  lease: "/ijara-maydonlar",
  market: "/yashil-olam",
  seedlings: "/kochat",
  terms: "/shartlar",
  privacy: "/maxfiylik",
};

/** Yo'riqnomalar endi «Biz haqimizda» sahifasining ichida; eski `/yoriqnomalar` shu manzilga yo'naltiriladi. */
export const GUIDES_HREF = "/haqida#yoriqnomalar";
/** Multimedia galereya endi «Yangiliklar» sahifasining pastida; eski `/media` shu manzilga yo'naltiriladi. */
export const MEDIA_HREF = "/yangiliklar#media";
/** Bosh sahifaning oxirgi bloki «Ko'p beriladigan savollar»; eski `/savol-javob` shu yerga yo'naltiriladi. */
export const FAQ_ANCHOR = "savol-javob";
export const FAQ_HREF = `/#${FAQ_ANCHOR}`;
/** Bosh sahifadagi yangiliklar blokining `id`si — yon menyu va «Yangiliklar» havolasi shunga o'tadi. */
export const NEWS_ANCHOR = "yangiliklar";
/** Bosh sahifadagi «Elektron yashil olam» blokining `id`si. */
export const MARKET_ANCHOR = "yashil-olam";
/** Bosh sahifaning yangiliklar bloki manzili. */
export const HOME_NEWS_HREF = `/#${NEWS_ANCHOR}`;

/**
 * `#about` → `/haqida`; jadvalda yo'q anchor yoki oddiy yo'l o'zgarmaydi.
 * `#news` — bosh sahifadagi yangiliklar bloki (to'liq ro'yxat: `SECTION_PATHS.news`).
 */
export function sectionHref(href: string): string {
  if (!href.startsWith("#")) return href;
  if (href === "#news") return HOME_NEWS_HREF;
  if (href === "#guides") return GUIDES_HREF;
  if (href === "#media") return MEDIA_HREF;
  if (href === "#faq") return FAQ_HREF;
  return SECTION_PATHS[href.slice(1)] ?? "/";
}

/** Joriy yo'lga mos bo'lim kaliti (menyuda faol bandni belgilash uchun). */
export function sectionIdForPath(pathname: string): string {
  /* `/xizmatlar/ruxsatnoma` kabi ichki sahifalar ham o'z bo'limini faol qiladi. */
  const entry = Object.entries(SECTION_PATHS).find(
    ([, path]) => path === pathname || pathname.startsWith(`${path}/`),
  );
  /* Kuzatish — murojaat sahifasining bir qismi: menyuda «Murojaat» faol bo'ladi. */
  if (entry?.[0] === "tracking") return "appeal";
  return entry ? entry[0] : "";
}
